import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selectorPanel"] // "multipleUrlsActivated"

  connect() {
    const includeSelectAll = parseInt($('select.multiselect').data("limit")) > 23

    const disableOptionsOnLimit = function(select, selectedOption = null) {
      const maxNumber = parseInt(select.data("limit"))
      const selectedOptions = select.find('option:selected')

      if (maxNumber === 1) {
        if (selectedOption) {
          return select.find('option').each(function() {
            if ($(this).val() !== selectedOption.val()) {
              return $('select.multiselect').multiselect("deselect", $(this).val())
            }
          })
        }
      } else {
        if (selectedOptions.length >= maxNumber) {
          const nonSelectedOptions = select.find('option').filter(function() {
            return !$(this).is(':selected')
          })

          return nonSelectedOptions.each(function() {
            const input = select.parent().find(`input[value="${$(this).val()}"]`)
            input.prop('disabled', true)
            return input.parents('li').addClass('disabled')
          })
        } else {
          return select.find('option').each(function() {
            const input = select.parent().find(`input[value="${$(this).val()}"]`)
            input.prop('disabled', false)
            return input.parents('li').removeClass('disabled')
          })
        }
      }
    }


    $('select.multiselect').multiselect({
      maxHeight: 200,

      buttonClass: 'btn btn-info',
      includeSelectAllOption: includeSelectAll,
      selectAllText: "<span class='checkbox-placeholder'></span> Select all",
      enableHTML: true,
      onInitialized(select, container) {
        const options_number = $(select).find("option").size()

        if (options_number > 24) {
          $(container).find("input[value=select-each-hour]").parents("a").addClass("multiselect-all")
        }

        return disableOptionsOnLimit(select)
      },
      onChange(option, checked) {
        const select = option.parent()

        if (option.val() === 'select-each-hour') {
          select.find('option').each(function() {
            option = $(this)
            const value = option.val()
            if ((option.val().length === 0) || value.match(/hh/)) { return; }

            if (checked) {
              return $('select.multiselect').multiselect("select", value)
            } else {
              return $('select.multiselect').multiselect("deselect", value)
            }
          })
          return
        }

        if (!select.data("limit")) { return; }

        return disableOptionsOnLimit(select, checked ? option : null)
      },

      optionLabel(element) {
        const text = $(element).attr('label') || $(element).text()
        return `<span class='checkbox-placeholder'></span> ${text}`
      },
      buttonText(options) {
        if (options.length === 0) {
          return "Select hours"
        } else if (options.length > 47) {
          return "Every 30 minutes"
        } else if (options.length > 5) {
          let number = options.length
          options.each(function() {
            if ($(this).val() === "select-each-hour") {
              return number -= 1
            }
          })

          return `${number} selected`
        } else {
          let selected = ''
          options.each(function(i) {
            selected += $(this).text()
            if (i !== (options.length - 1)) {
              return selected += ', '
            }
          })
          return selected.substr(0, selected.length)
        }
      }
    })

    const tagsinput = $('#categories-tagsinput').tagsinput({
      typeaheadjs: {
        source(query, syncResults, asyncResults) {
          return syncResults($('#categories-tagsinput').data("values"))
        }
      }})

    tagsinput.forEach(function(widget) {
      const input = widget.input()

      input.focusout(() => widget.add(input.val()))
      return input.typeahead('val', '')
    })

    $(".reload-iframe").on("click", function(e) {
      const $button = $(e.target)
      const $iframeWidget = $button.parents(".iframe-widget")
      $iframeWidget.find(".error").slideUp("slow")
      $iframeWidget.find(".loader-small").slideDown("slow")

      const $iframe = $iframeWidget.find("iframe")
      return $iframe.attr("src", $iframe.attr("src"))
    })

    $("#track_selector").on("change", function() {
      $("#tab-area iframe").contents()[0].defaultView.selector_looker.updatePath($("#track_selector").val())
      return $(".selector-help-block").show()
    })

    $("#tab-area-label").on("show.bs.tab", () => this.loadResponsiveIframe("#selector-iframe", $("#track_selector").val()))

    $("#tab-preview-label").on("show.bs.tab", () => this.loadResponsiveIframe("#preview-iframe"))

    if ($("#tab-preview").hasClass("active")) {
      this.loadResponsiveIframe("#preview-iframe")
    }

    $('body').bind('selector.update', function(target, selector) {
      if (!selector) { return; }

      $("#track_selector").val(selector)
      return $(".selector-help-block").show()
    })

    $('body').bind('selector.update_count', (target, count) => $("#selector_count").text(count))
  }

  serializeForm(form) {
    const disabled = form.find(':input:disabled').removeAttr('disabled')
    const serialized = form.serialize()
    disabled.attr('disabled','disabled')
    return serialized
  }

  iframeError($iframeWidget, message) {
    $iframeWidget.find("iframe").hide()
    $iframeWidget.find(".error-text").text(message)
    return $iframeWidget.find(".error").slideDown("slow")
  }

  loadResponsiveIframe(selector, areaSelector = null) {
    const $iframeWidget = $(selector)
    $iframeWidget.find(".error").hide()
    $iframeWidget.slideDown("slow")

    const iframeUrl = $iframeWidget.data('url') + '?' + this.serializeForm($iframeWidget.parents("form"))

    const $loader = $iframeWidget.find(".loader-small")
    $loader.show()

    const $iframe = $iframeWidget.find("iframe")
    $iframe.slideUp("slow")

    $iframe.off("load")

    $iframe.attr('src', iframeUrl)

    const ctrl = this

    return $iframe.on("load", function() {
      const $content = $iframe.contents()

      $content.find('a').click(e => e.preventDefault())

      if (areaSelector && (areaSelector.length > 0)) {
        $content[0].defaultView.jQuerySG(function() {
          $content[0].defaultView.selector_looker.updatePath(areaSelector)
          return $(".selector-help-block").show()
        })
      }

      const $body = $content.find('body')
      if ($body.length === 0) {
        ctrl.iframeError($iframeWidget, "There is not HTML code on this page")
      } else if ($body.data('urlooker-error')) {
        ctrl.iframeError($iframeWidget, $body.data('urlooker-error'))
      }

      $loader.slideUp("slow")
      return $iframe.slideDown("slow")
    })
  }

  updateUrl() {
    // if (this.multipleUrlsActivatedTarget.value === "true") { return; }
    if (!$("#tab-area").hasClass("active")) { return; }
    this.loadResponsiveIframe("#selector-iframe", $("#track_selector").val())
  }

  editSelector() {
    const selectorInput = $('#track_selector')
    selectorInput.removeAttr("readonly")
    return selectorInput.focus()
  }

  clearSelector() {
    const selectorInput = $('#track_selector')
    selectorInput.val("")
    $("#selector_count").text(0)
    return $("#tab-area iframe").contents()[0].defaultView.selector_looker.clearSelected(null)
  }

  save(event) {
    const $button = $(event.target)
    if ($button.hasClass('disabled')) {
      return e.preventDefault()
    } else {
      $button.find('.fa-spin').removeClass('hidden')
      $button.addClass('disabled')
      return setTimeout(function() {
          $button.find('.fa-spin').addClass('hidden')
          return $button.removeClass('disabled')
        }
        , 20000)
    }
  }

  deactivateMultipleUrls() {
    this.multipleUrlsActivatedTarget.value = null
  }

  activateMultupleUrls() {
    this.multipleUrlsActivatedTarget.value = true
    this.selectorPanelTarget.classList.add("hidden")
  }
}
